<template>
  <fragment>
    <AppBody title="Pessoas / Usuários" subtitle="Usuários" :actions="actions">
      <v-form
        @submit.prevent="$pessoas_usuarios.filtroUsuarios()"
        class="search-forms"
      >
        <v-row>
          <v-col cols="4">
            <label class="input-labels"> Nome </label>
            <v-text-field
              solo
              placeholder="Insira o nome do usuário"
              v-model="$pessoas_usuarios.filter.nome"
              type="text"
              data-cy="nome"
              class="textinput"
            ></v-text-field>
          </v-col>
          <v-col cols="4">
            <label class="input-labels"> E-mail </label>
            <v-text-field
              solo
              placeholder="Insira o e-mail"
              v-model="$pessoas_usuarios.filter.email"
              type="text"
              data-cy="email"
              class="textinput"
            ></v-text-field>
          </v-col>
          <v-col cols="4">
            <label class="input-labels"> Status </label>
            <v-select
              height="48"
              :items="status"
              dense
              solo
              data-cy="status"
              class="textinput"
              item-text="text"
              item-value="value"
              v-model="$pessoas_usuarios.filter.status"
              placeholder="Selecione o status"
              :color="$config.dados.corinputs"
              clearable
              clear-icon="mdi-close-circle-outline"
              @click:clear-icon="clearFilterFields('status')"
              :item-color="$config.dados.corinputs"
            >
            </v-select>
          </v-col>
          <v-col cols="4">
            <label class="input-labels"> Data inicial do cadastro </label>
            <!-- <v-menu ref="menu" v-model="menu" :close-on-content-click="false"
                                transition="scale-transition" offset-y min-width="auto">
                                <template v-slot:activator="{ on, attrs }">
                                    <v-text-field v-model="dtInicial" :prepend-icon="$config.icons.calendar" readonly
                                        v-bind="attrs" v-on="on" solo  class="pessoas-usuarios-textinput3"
                                        :placeholder="placeholderData" :color="$config.dados.corinputs"></v-text-field>
                                </template>
                                <v-date-picker v-model="$pessoas_usuarios.filter.dataInicio" :active-picker.sync="activePicker"
                                    :max="(new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10)"
                                    min="1950-01-01" @change="save" locale="pt" :header-color="$config.dados.corinputs"
                                    landscape :color="$config.dados.corinputs"></v-date-picker>
                            </v-menu> -->
            <v-text-field
              v-model="$pessoas_usuarios.filter.dataInicio"
              type="tel"
              data-cy="data-inicial"
              class="textinput"
              v-mask="['XX/XX/XXXX']"
              placeholder="dd/mm/aaaa"
              hide-details
              solo
              append-icon="mdi-calendar-blank-outline"
            ></v-text-field>
          </v-col>
          <v-col cols="4">
            <label class="input-labels"> Data final do cadastro </label>
            <!-- <v-menu ref="menu2" v-model="menu2" :close-on-content-click="false"
                                transition="scale-transition" offset-y min-width="auto">
                                <template v-slot:activator="{ on, attrs }">
                                    <v-text-field v-model="dtFinal" :prepend-icon="$config.icons.calendar" readonly
                                        v-bind="attrs" v-on="on" solo  class="pessoas-usuarios-textinput3"
                                        :placeholder="placeholderData" :color="$config.dados.corinputs"></v-text-field>
                                </template>
                                <v-date-picker v-model="$pessoas_usuarios.filter.dataFim" :active-picker.sync="activePicker2"
                                    :max="(new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10)"
                                    min="1950-01-01" @change="save2" locale="pt" :header-color="$config.dados.corinputs"
                                    :color="$config.dados.corinputs" landscape></v-date-picker>
                            </v-menu> -->
            <v-text-field
              v-model="$pessoas_usuarios.filter.dataFim"
              type="tel"
              data-cy="data-final"
              class="textinput"
              v-mask="['XX/XX/XXXX']"
              placeholder="dd/mm/aaaa"
              hide-details
              solo
              append-icon="mdi-calendar-blank-outline"
            ></v-text-field>
          </v-col>
          <v-col cols="2" align-self="end" data-cy="filtrar" class="ml-auto">
            <v-btn height="48" class="button btn-size btn-border" type="submit">
              Filtrar
            </v-btn>
          </v-col>
        </v-row>
        <!-- <label class="pessoas-usuarios-text11 input-labels">
                            Perfil
                        </label>
                        <v-select height="48" :items="perfis" dense solo  class="pessoas-usuarios-textinput5"
                        v-model="$pessoas_usuarios.filter.nidperfil" placeholder="Selecione os perfis" multiple
                        :color="$config.dados.corinputs" deletable-chips chips small-chips
                        :item-color="$config.dados.corinputs"></v-select> -->
      </v-form>
      <v-data-table
        class="table-body"
        item-key="idusuario"
        no-data-text="Não há registro de usuários"
        loading-text="Buscando informações..."
        :loading="$pessoas_usuarios.usuarios_loading"
        :headers="headers"
        :items="filteredUsers"
        :items-per-page="10"
        :footer-props="{
          itemsPerPageOptions: [10, 20, 50],
          itemsPerPageText: 'Usuários por página',
        }"
      >
        <template v-slot:item.ins_dthr="{ item }">
          {{ item.ins_dthr | dthr_pt_br }}
        </template>
        <template v-slot:item.actions="{ item }" class="table-actions">
          <div style="display: flex; justify-content: center">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  :color="$config.dados.corinputs"
                  height="30"
                  width="30"
                  small
                  icon
                  v-bind="attrs"
                  v-on="on"
                  @click="goToUser('editar', item)"
                  class="mr-2"
                >
                  <v-icon>mdi-pencil-outline</v-icon>
                </v-btn>
              </template>
              <span>Editar</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-if="item.status == 'ATIVO'"
                  :color="$config.dados.corinputs"
                  height="30"
                  v-bind="attrs"
                  v-on="on"
                  width="30"
                  small
                  icon
                  @click="$pessoas_usuarios.desabilitarUsuario(item.idusuario)"
                >
                  <v-icon>mdi-account-cancel-outline</v-icon>
                </v-btn>
              </template>
              <span>Desativar</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-if="item.status == 'INATIVO'"
                  :color="$config.dados.corinputs"
                  height="30"
                  v-bind="attrs"
                  v-on="on"
                  width="30"
                  small
                  icon
                  @click="$pessoas_usuarios.habilitarUsuario(item.idusuario)"
                >
                  <v-icon>mdi-account-check-outline</v-icon>
                </v-btn>
              </template>
              <span>Ativar</span>
            </v-tooltip>
          </div>
        </template>
      </v-data-table>
    </AppBody>
  </fragment>
</template>

<script>
export default {
  name: "Usuarios",
  components: {
    AppBody: () => import("@/layouts/components/AppBody.vue"),
  },
  metaInfo: {
    title: "Pessoas/Usuarios | ElevenTickets",
    meta: [
      {
        property: "og:title",
        content: "Pessoas/Usuarios | ElevenTickets",
      },
    ],
  },
  data() {
    return {
      actions: [
        {
          name: "Novo Usuário",
          action: () => this.goToUser("new", ""),
        },
      ],
      status: ["ATIVO", "INATIVO"],
      // activePicker: null,
      // activePicker2: null,
      // date: null,
      // menu: false,
      // menu2: false,
      // dtInicial: '',
      // dtFinal: '',
      placeholderData: "dd/mm/aa",
      perfis: [
        "Operações",
        "Atendimento B2B",
        "Atendimento B2C",
        "Configurador",
        "Financeiro",
        "Analista",
        "Gerente",
        "Diretor",
        "Jurídico",
        "Admin",
        "Comercial",
      ],
      headers: [
        {
          text: "Nome",
          align: "center",
          sortable: true,
          value: "nome",
        },
        {
          text: "E-mail",
          align: "center",
          sortable: true,
          value: "email",
        },
        {
          text: "Data de cadastro",
          align: "center",
          sortable: true,
          value: "ins_dthr",
        },
        {
          text: "Status",
          align: "center",
          sortable: true,
          value: "status",
        },
        {
          text: "Ações",
          align: "center",
          sortable: false,
          fixed: false,
          value: "actions",
        },
      ],
    };
  },
  computed: {
    filteredUsers() {
      return this.$pessoas_usuarios.usuarios;

      // if(this.$pessoas_usuarios.usuarios) {
      //     return _.orderBy(this.$pessoas_usuarios.usuarios, ['status', 'ins_dthr'], ['asc', 'desc']);
      // }
    },
  },
  // watch: {
  //     menu(val) {
  //         val && setTimeout(() => (this.activePicker = 'YEAR'))
  //     },
  //     menu2(val) {
  //         val && setTimeout(() => (this.activePicker2 = 'YEAR'))
  //     },
  // },
  methods: {
    clearFilterFields(field) {
      switch (field) {
        case "status":
          this.$pessoas_usuarios.filter.status = "";
          break;
        default:
          break;
      }
    },
    goToUser(type, data) {
      this.$pessoas_usuarios.usuarioAddEdit = type;
      if (type === "editar") {
        this.$router.push({
          name: "userSettings",
          params: {
            type: "editar",
          },
        });
        this.$pessoas_usuarios.cadastro.nome = data.nome;
        this.$pessoas_usuarios.cadastro.avatar.imagem = data.avatar;
        this.$pessoas_usuarios.cadastro.email = data.email;
        this.$pessoas_usuarios.cadastro.senha = data.senha;
        this.$pessoas_usuarios.cadastro.urlHome = data.urlHome;
        this.$pessoas_usuarios.cadastro.status = data.status;
        this.$pessoas_usuarios.cadastro.iduser = data.idusuario;
        return;
      }
      this.$router.push({
        name: "userSettings",
        params: {
          type: "cadastrar",
        },
      });
    },
  },
  mounted() {
    this.$pessoas_usuarios.getUsuarios();
  },
  destroyed() {
    this.$pessoas_usuarios.limpaFilterDeUsuario();
  },
};
</script>

<style scoped>
.pessoas-usuarios-button3 {
  color: var(--dl-color-gray-white);
  width: 30px;
  height: 30px;
  display: flex;
  padding: 0;
  align-items: center;
  border-width: 0;
  margin-right: 0.625rem;
  flex-direction: row;
  justify-content: center;
  background-color: var(--dl-color-gray-black);
}
</style>
